import { ReactNode } from "react";
import { LessonI } from "../../types";
import VideoComponent from "../CreateLessonPage/components/contentComponents/VideoComponent";

type TopicTrailerProps = {
  header: ReactNode;
  trailerVideoUrl?: string;
  trailerTranscript?: string;
  topicTocEnabled: boolean;
  firstLesson?: LessonI;
  continueLesson?: LessonI;
  onClickLesson: (lessonId: string) => void;
};

const TopicTrailer = ({
  header,
  trailerVideoUrl,
  trailerTranscript,
  topicTocEnabled,
  firstLesson,
  continueLesson,
  onClickLesson,
}: TopicTrailerProps) => {
  const trailerVideo = trailerVideoUrl?.trim() ? (
    <VideoComponent
      url={trailerVideoUrl.trim()}
      transcript={trailerTranscript}
      fitInContainer
    />
  ) : null;

  const trailerCTAs =
    topicTocEnabled && firstLesson?._id ? (
      <div className="flex flex-col lg:flex-row gap-3 mt-4 w-full self-stretch">
        {continueLesson && (
          <div
            role="button"
            tabIndex={0}
            className="w-full lg:flex-1 min-w-0 truncate font-bold py-2 px-4 shadow bg-electrum text-white hover:bg-electrum-150 hover:text-electrum rounded-full h-10 text-base transition-all duration-150 ease-in-out cursor-pointer flex items-center justify-center"
            onClick={() => onClickLesson(continueLesson._id)}
            onKeyDown={(e) =>
              e.key === "Enter" && onClickLesson(continueLesson._id)
            }
          >
            <span className="truncate">
              Continue: {continueLesson.title}
            </span>
          </div>
        )}
        <div
          role="button"
          tabIndex={0}
          className={`w-full lg:flex-1 min-w-0 truncate font-bold py-2 px-4 shadow rounded-full h-10 text-base transition-all duration-150 ease-in-out cursor-pointer flex items-center justify-center ${
            continueLesson
              ? "bg-white text-electrum border-2 border-electrum hover:bg-electrum-150 hover:text-electrum hover:border-electrum"
              : "bg-electrum text-white hover:bg-electrum-150 hover:text-electrum"
          }`}
          onClick={() => onClickLesson(firstLesson._id)}
          onKeyDown={(e) =>
            e.key === "Enter" && onClickLesson(firstLesson._id)
          }
        >
          <span className="truncate">
            {continueLesson ? "Restart" : "Start"}: {firstLesson.title}
          </span>
        </div>
      </div>
    ) : null;

  return (
    <>
      {/* Video — shown above header on mobile, below on lg */}
      {trailerVideo && (
        <div className="w-full min-w-0 mb-4 lg:order-2 lg:mb-0 lg:mt-4">
          {trailerVideo}
          {trailerCTAs && <div className="hidden lg:block">{trailerCTAs}</div>}
        </div>
      )}

      {/* Header + mobile CTAs */}
      <div className="w-full min-w-0 lg:order-1">
        {header}
        {trailerCTAs && <div className="mt-4 lg:hidden">{trailerCTAs}</div>}
      </div>
    </>
  );
};

export default TopicTrailer;
